import React, { useMemo } from 'react';

import { usePageContent } from '~/App/shared/hooks/use-page-content';

import { loadData } from './CmsProduct.LoadData';
import { CmsProduct } from './CmsProduct';

const View = (props: unknown) => {
  const pageContent = usePageContent();
  const children = useMemo(
    () => (pageContent ? <CmsProduct {...pageContent} {...props} /> : null),
    [pageContent, props]
  );

  return children;
};

View.loadData = loadData;

export default View;
